import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";

import { useNavigate } from "react-router-dom";

import Sidebar from "@/components/Sidebar";

import api, { formatApiError } from "@/lib/api";

import { toast } from "sonner";

import {

  Phone,

  Mic,

  Settings2,

  ArrowUpRight,

  CheckCircle2,

  Clock3,

  Users,

  CalendarDays,

  Sparkles,

  ShieldCheck,

  ChevronRight,

  Loader2,

  XCircle,

  Building2,

  Headset,

  ArrowRight,

  SlidersHorizontal,

  AudioLines,

  Bot,

} from "lucide-react";



export default function Receptionist() {

  const navigate = useNavigate();



  const [config, setConfig] = useState(null);

  const [configLoading, setConfigLoading] = useState(true);

  const [business, setBusiness] = useState(null);

  //const configured = !!config;

  const configured = config?.retell?.connected === true &&

  !!config?.retell?.agent_id;

  const [calls, setCalls] = useState([]);

  const [callsLoading, setCallsLoading] = useState(true);

  const [callsError, setCallsError] = useState(null);

  const [appointments, setAppointments] = useState([]);

  const [appointmentsLoading, setAppointmentsLoading] = useState(true);



  useEffect(() => {

      let mounted = true;



      const loadConfig = async () => {

        try {

          setConfigLoading(true);



          const { data } = await api.get("/receptionist/config");



          if (mounted) {

            setConfig(data || null);

          }

        } catch (error) {

          if (mounted) {

            const message =

              formatApiError(error?.response?.data?.detail) ||

              "Unable to load receptionist configuration.";



            toast.error(message);

          }

        } finally {

          if (mounted) {

            setConfigLoading(false);

          }

        }

      };



      const loadBusiness = async () => {

        try {

          const response = await fetch("/api/business", {

            method: "GET",

            credentials: "include",

            headers: {

              Accept: "application/json",

            },

          });



          if (!response.ok) {

            throw new Error(`Failed to load business: ${response.status}`);

          }



          const data = await response.json();



          setBusiness(data?.configured ? data?.business || null : null);

        } catch (error) {

          console.error("Failed to load business:", error);

          setBusiness(null);

        }

      };



      loadConfig();

      loadBusiness();

      return () => {

        mounted = false;

      };

    }, []);



  useEffect(() => {

  let mounted = true;



  const loadCalls = async () => {

    try {

      setCallsLoading(true);

      setCallsError(null);



      const { data } = await api.get("/retell/calls");



      if (mounted) {

        setCalls(Array.isArray(data) ? data : data?.calls || []);

      }

    } catch (error) {

      if (mounted) {

        const message =

          formatApiError(error?.response?.data?.detail) ||

          "Unable to load call history.";



        setCallsError(message);

        toast.error(message);

      }

    } finally {

      if (mounted) {

        setCallsLoading(false);

      }

    }

  };



  loadCalls();



  return () => {

    mounted = false;

  };

  }, []);



  useEffect(() => {

    let mounted = true;



    const loadAppointments = async () => {

      try {

        setAppointmentsLoading(true);



        const today = new Date().toISOString().slice(0, 10);



        const { data } = await api.get("/appointments", {

          params: {

            date: today,

          },

        });



        if (mounted) {

          setAppointments(

            Array.isArray(data)

              ? data

              : data?.appointments || []

          );

        }

      } catch (error) {

        if (mounted) {

          setAppointments([]);

        }

      } finally {

        if (mounted) {

          setAppointmentsLoading(false);

        }

      }

    };



    loadAppointments();



    return () => {

      mounted = false;

    };

  }, []);



  if (configLoading) {

    return (

      <div className="min-h-screen bg-[#F4F3EB]">

        <Sidebar />



        <main className="nexa-compact lg:ml-[260px] min-h-screen bg-[#F4F6F2]">

          <div className="flex min-h-screen items-center justify-center">

            <div className="flex items-center gap-2 text-sm text-slate-500">

              <Loader2 size={18} className="animate-spin" />

              Loading AI Receptionist...

            </div>

          </div>

        </main>

      </div>

    );

  }



  const todayKey = new Date().toISOString().slice(0, 10);



  const todayCalls = (calls || []).filter((call) => {

    const value =

      call.started_at ||

      call.start_timestamp ||

      call.created_at;



    if (!value) return false;



    const date = new Date(value);



    return (

      !Number.isNaN(date.getTime()) &&

      date.toISOString().slice(0, 10) === todayKey

    );

  });



  const aiAppointmentsToday = (appointments || []).filter((appointment) => {

    if (appointment.booking_source !== "ai_receptionist") {

      return false;

    }



    if (appointment.date === todayKey) {

      return true;

    }



    if (appointment.start_time) {

      const date = new Date(appointment.start_time);



      return (

        !Number.isNaN(date.getTime()) &&

        date.toISOString().slice(0, 10) === todayKey

      );

    }



    return false;

  });



  const durations = todayCalls

    .map((call) => {

      const value =

        call.duration_seconds ??

        call.duration ??

        (call.duration_ms != null

          ? Number(call.duration_ms) / 1000

          : null);



      const seconds = Number(value);



      return Number.isFinite(seconds) && seconds > 0

        ? seconds

        : null;

    })

    .filter((value) => value !== null);



  const avgDurationSeconds =

    durations.length > 0

      ? durations.reduce((sum, value) => sum + value, 0) / durations.length

      : null;



  const receptionistMetrics = {

    callsToday: todayCalls.length,

    aiAppointmentsToday: aiAppointmentsToday.length,

    avgDurationSeconds,

  };



  return (

    <div className="min-h-screen bg-[#F4F3EB]">

        <Sidebar />



      <main className="nexa-compact lg:ml-[260px] min-h-screen bg-[#F4F6F2]">

      <div className="w-full px-3 md:px-5 py-3 md:py-4">


      {!configured ? (

        <motion.section

          initial={{ opacity: 0, y: 10 }}

          animate={{ opacity: 1, y: 0 }}

          className="relative mb-4 overflow-hidden rounded-2xl border border-[#D9E8E3] bg-gradient-to-r from-[#EFF8F3] via-white to-[#F8F8F1] shadow-[0_5px_18px_rgba(15,70,75,0.035)]"

        >

          <div className="grid gap-4 p-4 md:grid-cols-[minmax(0,1fr)_220px] md:items-center md:p-4">

            <div className="flex items-start gap-4">

              <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border border-[#CBE5DA] bg-[#E5F3ED] text-[#075B59]">

                <Bot size={32} strokeWidth={1.6} />

              </div>



              <div className="min-w-0">

                <div className="mb-2 flex flex-wrap items-center gap-2">

                  <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#718780]">

                    AI OPERATIONS

                  </span>

                  <StatusBadge active={false} label="Setup incomplete" />

                </div>



                <h1 className="text-3xl font-semibold tracking-tight text-[#102C2D]">

                  Nexa

                </h1>



                <h2 className="mt-1 text-base font-medium text-[#244C49]">

                  Your 24/7 AI receptionist

                </h2>



                <p className="mt-2 max-w-xl text-sm leading-6 text-[#71817C]">

                  Set up Nexa to answer customer calls, understand business

                  questions and assist with appointments using your business information.

                </p>

              </div>

            </div>



            <div className="flex flex-col gap-3 md:border-l md:border-[#DDE8E3] md:pl-5">

              <div className="flex items-start gap-3">

                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#E8F4EF] text-[#075B59]">

                  <Phone size={17} />

                </div>

                <div>

                  <p className="text-xs text-[#82938D]">Business phone</p>

                  <p className="mt-1 text-sm font-medium text-[#102C2D]">

                    {business?.phone || "Not connected"}

                  </p>

                </div>

              </div>



              <div className="flex items-start gap-3">

                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#E8F4EF] text-[#075B59]">

                  <Mic size={17} />

                </div>

                <div>

                  <p className="text-xs text-[#82938D]">Voice & language</p>

                  <p className="mt-1 text-sm font-medium text-[#102C2D]">

                    {config?.voice || "Not configured"}

                  </p>

                </div>

              </div>



              <button

                type="button"

                onClick={() => navigate("/receptionist/setup")}

                className="mt-1 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#075B59] px-4 py-3 text-sm font-semibold text-white transition hover:bg-[#064B49]"

              >

                Start setup

                <ArrowRight size={16} />

              </button>



              <p className="text-xs leading-5 text-[#71817C]">

                Configure your receptionist and connect your phone to get started.

              </p>

            </div>

          </div>

        </motion.section>

      ) : (

        <>

          <ReceptionistHero

            configured={configured}

            config={config}

            business={business}

            onManage={() => navigate("/receptionist/setup")}

          />

        <ReceptionistMetrics metrics={receptionistMetrics} />

        </>

      )}

      <NexaJourney

        businessComplete={Boolean(business)}

        receptionistComplete={Boolean(config?.retell?.agent_id)}

        phoneConnected={config?.retell?.connected === true}

        configured={configured}

        receptionistName={config?.receptionistName || "Nexa"}

        onBusinessSetup={() => navigate("/business-settings/profile")}

        onReceptionistSetup={() => navigate("/receptionist/setup")}

      />
     
  {/* Calls section remains inside the padded content wrapper */}
 <section className="mt-4 rounded-xl border border-[#E3E5D9] bg-white p-2 md:p-3">
    <div className="overflow-hidden rounded-xl border border-[#E3E5D9] bg-[#FFFDF8] shadow-[0_3px_12px_rgba(16,44,45,0.035)]">  
    {/* Header */}

    <div className="flex flex-col gap-2 border-b border-[#E3E5D9] bg-[#F7F7F2] px-4 py-3 sm:flex-row sm:items-center sm:justify-between">

      <div>

        <div className="flex items-center gap-2">

          <Phone size={18} className="text-[#087D79]" />



          <h2 className="text-[15px] font-semibold text-[#102C2D]">

            Calls

          </h2>

        </div>



        <p className="mt-1 text-[12px] text-[#71817C]">

          Recent conversations handled by {config?.receptionistName || "Nexa"}.

        </p>

      </div>



      {!callsLoading && calls.length > 0 && (

        <div className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-600">

          {calls.length} {calls.length === 1 ? "call" : "calls"}

        </div>

      )}

    </div>



    {/* Loading */}

    {callsLoading && (

      <div className="flex min-h-[180px] items-center justify-center px-5">

        <div className="flex items-center gap-2 text-sm text-slate-500">

          <Loader2 size={17} className="animate-spin" />

          Loading calls...

        </div>

      </div>

    )}



    {/* Error */}

    {!callsLoading && callsError && (

      <div className="px-5 py-10 text-center">

        <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-red-50 text-red-600">

          <XCircle size={20} />

        </div>



        <p className="mt-3 text-sm font-medium text-slate-800">

          Unable to load calls

        </p>



        <p className="mt-1 text-sm text-slate-500">

          {callsError}

        </p>

      </div>

    )}



    {/* Empty */}

    {!callsLoading && !callsError && calls.length === 0 && (

      <div className="px-4 py-8 text-center">

        <div className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-[#E8F4EF] text-[#075B59]">
          <Phone size={19} />
        </div>



        <p className="mt-3 text-[13px] font-semibold text-[#102C2D]">
          No calls yet
        </p>

        <p className="mx-auto mt-1 max-w-sm text-[12px] leading-5 text-[#71817C]">
          Calls handled by {config?.receptionistName || "Nexa"} will appear here.
        </p>

      </div>

    )}



    {/* Desktop table */}

    {!callsLoading && !callsError && calls.length > 0 && (

      <div className="hidden overflow-x-auto md:block">

        <table className="w-full min-w-[760px]">

          <thead>

            <tr className="border-b border-[#E8E8DE] bg-[#F7F7F0]">

              <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.12em] text-[#71817C]">

                Caller

              </th>



              <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.12em] text-[#71817C]">

                Date & Time

              </th>



              <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.12em] text-[#71817C]">

                Duration

              </th>



              <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.12em] text-[#71817C]">

                Direction

              </th>



              <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.12em] text-[#71817C]">

                Outcome

              </th>



              <th className="px-4 py-3 text-left text-[10px] font-semibold uppercase tracking-[0.12em] text-[#71817C]">

                Status

              </th>

            </tr>

          </thead>



          <tbody>

            {calls.map((call, index) => (

              <tr

                key={call.id || call.call_id || index}

                className="border-b border-[#EEEFE7] last:border-b-0 hover:bg-[#F8F8F2]"

              >

                <td className="px-5 py-4">

                  <div className="flex items-center gap-3">

                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-700">

                      <Phone size={15} />

                    </div>



                    <span className="text-sm font-medium text-slate-900">

                      {call.caller_phone ||

                        call.from_number ||

                        call.phone_number ||

                        "Unknown caller"}

                    </span>

                  </div>

                </td>



                <td className="px-5 py-4 text-sm text-slate-600">

                  {formatCallDate(

                    call.started_at ||

                    call.start_timestamp ||

                    call.created_at

                  )}

                </td>



                <td className="px-5 py-4 text-sm text-slate-600">

                  {formatDuration(

                    call.duration_seconds ??

                    call.duration ??

                    call.duration_ms / 1000

                  )}

                </td>



                <td className="px-5 py-4 text-sm text-slate-600">

                  {formatDirection(call.direction)}

                </td>



                <td className="px-5 py-4">

                  <span className="text-sm text-slate-700">

                    {formatOutcome(

                      call.outcome ||

                      call.call_outcome

                    )}

                  </span>

                </td>



                <td className="px-5 py-4">

                  <span

                    className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${getStatusClass(

                      call.status

                    )}`}

                  >

                    {formatOutcome(call.status)}

                  </span>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    )}



    {/* Mobile cards */}

    {!callsLoading && !callsError && calls.length > 0 && (

      <div className="divide-y divide-slate-100 md:hidden">

        {calls.map((call, index) => (

          <div

            key={call.id || call.call_id || index}

            className="p-4"

          >

            <div className="flex items-start justify-between gap-3">

              <div className="flex min-w-0 items-center gap-3">

                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-700">

                  <Phone size={15} />

                </div>



                <div className="min-w-0">

                  <p className="truncate text-sm font-semibold text-slate-900">

                    {call.caller_phone ||

                      call.from_number ||

                      call.phone_number ||

                      "Unknown caller"}

                  </p>



                  <p className="mt-0.5 text-xs text-slate-500">

                    {formatCallDate(

                      call.started_at ||

                      call.start_timestamp ||

                      call.created_at

                    )}

                  </p>

                </div>

              </div>



              <span

                className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-medium ${getStatusClass(

                  call.status

                )}`}

              >

                {formatOutcome(call.status)}

              </span>

            </div>



            <div className="mt-4 grid grid-cols-2 gap-3">

              <div>

                <p className="text-[11px] uppercase tracking-wide text-slate-400">

                  Duration

                </p>



                <p className="mt-1 text-sm font-medium text-slate-700">

                  {formatDuration(

                    call.duration_seconds ??

                    call.duration ??

                    call.duration_ms / 1000

                  )}

                </p>

              </div>



              <div>

                <p className="text-[11px] uppercase tracking-wide text-slate-400">

                  Direction

                </p>



                <p className="mt-1 text-sm font-medium text-slate-700">

                  {formatDirection(call.direction)}

                </p>

              </div>



              <div className="col-span-2">

                <p className="text-[11px] uppercase tracking-wide text-slate-400">

                  Outcome

                </p>



                <p className="mt-1 text-sm font-medium text-slate-700">

                  {formatOutcome(

                    call.outcome ||

                    call.call_outcome

                  )}

                </p>

              </div>

            </div>

          </div>

        ))}

      </div>

    )}

    </div>

  </section>
  </div> 
  </main>

</div>

);

}



/* -------------------------------------------------------

   ACTIVE STATE

\------------------------------------------------------- */

function formatCallDate(value) {

  if (!value) return "—";



  const date = new Date(value);



  if (Number.isNaN(date.getTime())) {

    return "—";

  }



  return date.toLocaleString("en-IN", {

    day: "2-digit",

    month: "short",

    year: "numeric",

    hour: "2-digit",

    minute: "2-digit",

  });

}



function formatDuration(value) {

  if (value === null || value === undefined || value === "") {

    return "—";

  }



  const seconds = Number(value);



  if (!Number.isFinite(seconds)) {

    return "—";

  }



  const mins = Math.floor(seconds / 60);

  const secs = Math.floor(seconds % 60);



  if (mins === 0) {

    return `${secs}s`;

  }



  return `${mins}m ${String(secs).padStart(2, "0")}s`;

}



function formatDirection(value) {

  if (!value) return "—";



  const normalized = String(value).toLowerCase();



  if (normalized === "inbound") return "Inbound";

  if (normalized === "outbound") return "Outbound";



  return value;

}



function formatOutcome(value) {

  if (!value) return "—";



  return String(value)

    .replace(/[_-]/g, " ")

    .replace(/\b\w/g, (char) => char.toUpperCase());

}



function getStatusClass(status) {

  const normalized = String(status || "").toLowerCase();



  if (

    normalized === "ended" ||

    normalized === "completed" ||

    normalized === "analyzed"

  ) {

    return "bg-emerald-50 text-emerald-700";

  }



  if (

    normalized === "failed" ||

    normalized === "error"

  ) {

    return "bg-red-50 text-red-700";

  }



  return "bg-amber-50 text-amber-700";

}


function NexaJourney({
  businessComplete,
  receptionistComplete,
  phoneConnected,
  configured,
  receptionistName,
  onBusinessSetup,
  onReceptionistSetup,
}) {
  const steps = [
    {
      number: "01",
      title: "Understand your business",
      description:
        "Use your existing business profile, services, staff and working hours.",
      icon: <Building2 size={17} />,
      complete: businessComplete,
      action: onBusinessSetup,
      actionLabel: "Set up business",
    },
    {
      number: "02",
      title: "Configure your receptionist",
      description:
        "Choose the receptionist style, services, staff and appointment preferences.",
      icon: <SlidersHorizontal size={17} />,
      complete: receptionistComplete,
      action: onReceptionistSetup,
      actionLabel: "Configure",
    },
    {
      number: "03",
      title: "Connect and go live",
      description:
        "Connect the AI receptionist to a phone number and start receiving calls.",
      icon: <Phone size={17} />,
      complete: phoneConnected,
      action: onReceptionistSetup,
      actionLabel: "Connect phone",
    },
    {
      number: "04",
      title: `${receptionistName || "Shush"} gets to work`,
      description:
        "Answers calls, handles questions and assists with bookings 24/7.",
      icon: <Headset size={17} />,
      complete: configured,
      action: onReceptionistSetup,
      actionLabel: "Manage receptionist",
    },
  ];

  return (
    <section className="mb-4 rounded-xl border border-[#E0EAE6] bg-white/70 p-3.5 shadow-[0_3px_12px_rgba(15,70,75,0.025)]">
      {/* Heading — keep this wording unchanged */}
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[9px] font-semibold uppercase tracking-[0.16em] text-[#81948D]">
            Nexa Journey
          </p>

          <h2 className="mt-0.5 text-[17px] font-semibold leading-5 tracking-[-0.025em] text-[#102C2D]">
            From setup to customer service
          </h2>

          <p className="mt-1 text-[11px] leading-4 text-[#7A8B85]">
            Set up Nexa in a few steps and let it handle calls, questions and appointments.
          </p>
        </div>

        <StatusBadge
          active={configured}
          label={configured ? "Configured" : "Setup incomplete"}
        />
      </div>

      {/* Four compact cards with connecting arrows */}
      <div className="grid grid-cols-1 items-stretch gap-2 sm:grid-cols-2 xl:grid-cols-[minmax(0,1fr)_20px_minmax(0,1fr)_20px_minmax(0,1fr)_20px_minmax(0,1fr)]">
        {steps.map((step, index) => {
          const isNext =
            !configured &&
            !step.complete &&
            steps.slice(0, index).every((previous) => previous.complete);

          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={step.number}>
              <div
                className={`flex min-w-0 flex-col rounded-xl border p-3 transition ${
                  isLast && configured
                    ? "border-[#CBE9DF] bg-[#EFF8F4]"
                    : isNext
                    ? "border-[#B8DED2] bg-[#F4FAF7]"
                    : "border-[#E2ECE8] bg-white"
                }`}
              >
                <div className="mb-1.5 flex items-center gap-2">
                  <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#E8F4EF] text-[#075B59]">
                    {step.icon}
                  </div>

                  <span className="text-[10px] font-semibold tracking-wide text-[#91A29C]">
                    {step.number}
                  </span>

                  {step.complete && (
                    <CheckCircle2
                      size={12}
                      className="ml-auto shrink-0 text-[#159A78]"
                    />
                  )}
                </div>

                <h3 className="text-[12px] font-semibold leading-4 text-[#102C2D]">
                  {step.title}
                </h3>

                <p className="mt-1 text-[10px] leading-[15px] text-[#788B85]">
                  {step.description}
                </p>

                {!configured && !isLast && (
                  <button
                    type="button"
                    onClick={step.action}
                    className="mt-2 text-left text-[10px] font-semibold text-[#087D79] hover:text-[#064B49]"
                  >
                    {step.actionLabel} →
                  </button>
                )}

                {configured && isLast && (
                  <button
                    type="button"
                    onClick={step.action}
                    className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-lg border border-[#CBE5DA] bg-white/80 px-2 py-1.5 text-[10px] font-semibold text-[#075B59] transition hover:bg-white"
                  >
                    {step.actionLabel}
                    <ArrowRight size={12} />
                  </button>
                )}
              </div>

              {index < steps.length - 1 && (
                <div className="hidden items-center justify-center text-[#8BAFA8] xl:flex">
                  <ArrowRight size={15} />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </section>
  );
}

function ReceptionistHero({ configured, config, business, onManage }) {
  const receptionistName = "Nexa";
  const phone = business?.phone || "";
  const voice = config?.voice || config?.language || "";

  return (
    <motion.section
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative mb-4 overflow-hidden rounded-2xl border border-[#D9E8E3] bg-gradient-to-r from-[#EFF8F3] via-white to-[#F8F8F1] shadow-[0_5px_18px_rgba(15,70,75,0.035)]"
    >
      <div className="grid items-center gap-4 p-4 xl:grid-cols-[minmax(0,1.65fr)_minmax(255px,0.9fr)_220px] xl:gap-4 xl:p-4">
        {/* Nexa identity */}
        <div className="flex min-w-0 items-center gap-3">
          <div className="relative flex h-[80px] w-[80px] shrink-0 items-center justify-center rounded-full border border-[#C6E9DF] bg-[radial-gradient(circle,#D8F4EC_0%,#B7E8DD_58%,#EAF7F2_72%)] shadow-[inset_0_0_0_5px_rgba(255,255,255,0.45)]">
            <div className="relative h-[99px] w-[99px] shrink-0">
              <img
                src="/images/nexa-ai-avatar.png"
                alt="Nexa AI receptionist"
                className="h-full w-full rounded-full object-contain"
              />
            </div>
          </div>

          <div className="min-w-0">
            <div className="mb-1.5 flex flex-wrap items-center gap-2">
              <span className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.16em] text-[#718780]">
                <span className="h-2 w-2 rounded-full bg-[#087D79]" />
                AI OPERATIONS
              </span>
              <StatusBadge
                active={configured}
                label={configured ? "Configured" : "Setup incomplete"}
              />
            </div>

            <h1 className="font-serif text-[34px] font-semibold leading-none tracking-tight text-[#102C2D]">
              {receptionistName}
            </h1>
            <h2 className="mt-1 text-[16px] font-semibold leading-5 text-[#173F3D]">
              Your 24/7 AI receptionist
            </h2>
            <p className="mt-1.5 max-w-[520px] text-[12px] leading-[18px] text-[#71817C]">
              {configured
                ? "Nexa can answer calls, understand customer requests and assist with appointments using your business information."
                : "Set up Nexa to answer calls, understand customer requests and assist with appointments using your business information."}
            </p>
          </div>
        </div>

        {/* Connection details */}
        <div className="grid min-w-0 grid-cols-1 gap-3 border-t border-[#DDE8E3] pt-3 xl:border-l xl:border-t-0 xl:py-1 xl:pl-4">
          <div className="flex min-w-0 items-center gap-2.5">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#E5F3ED] text-[#075B59]">
              <Phone size={17} />
            </div>
            <div className="min-w-0">
              <p className="text-[11px] leading-4 text-[#82938D]">Business phone</p>
              <p
                className={`mt-0.5 whitespace-nowrap text-[12px] font-semibold ${
                  configured && phone ? "text-[#102C2D]" : "text-[#C47A13]"
                }`}
              >
                {configured && phone ? phone : "Not connected"}
              </p>
            </div>
          </div>

          <div className="flex min-w-0 items-center gap-2.5">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#E5F3ED] text-[#075B59]">
              <AudioLines size={17} />
            </div>
            <div className="min-w-0">
              <p className="text-[11px] leading-4 text-[#82938D]">Voice &amp; language</p>
              <p
                className={`mt-0.5 text-[12px] font-semibold leading-4 ${
                  configured && voice ? "text-[#102C2D]" : "text-[#C47A13]"
                }`}
              >
                {configured && voice ? voice : "Not configured"}
              </p>
            </div>
          </div>
        </div>

        {/* Primary action */}
        <div className="border-t border-[#DDE8E3] pt-3 xl:border-l xl:border-t-0 xl:py-1 xl:pl-4">
          <button
            type="button"
            onClick={onManage}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#075B59] px-3 py-2.5 text-[12px] font-semibold text-white shadow-sm transition hover:bg-[#064B49]"
          >
            {configured ? "Manage receptionist" : "Start setup"}
            <ArrowRight size={15} />
          </button>
          <p className="mt-2 text-[11px] leading-[17px] text-[#71817C]">
            {configured
              ? "Update voice, services, staff and working hours."
              : "Complete a few steps to activate your AI receptionist."}
          </p>
        </div>
      </div>
    </motion.section>
  );
}

function ReceptionistMetrics({ metrics }) {

  const cards = [

    {

      label: "CALLS TODAY",

      value: metrics.callsToday,

      helper:

        metrics.callsToday === 0

          ? "No calls yet"

          : `${metrics.callsToday} ${

              metrics.callsToday === 1 ? "call" : "calls"

            } handled today`,

      icon: <Phone size={23} />,

    },

    {

      label: "APPOINTMENTS",

      value: metrics.aiAppointmentsToday,

      helper:

        metrics.aiAppointmentsToday === 0

          ? "No AI bookings yet"

          : `${metrics.aiAppointmentsToday} ${

              metrics.aiAppointmentsToday === 1

                ? "AI booking"

                : "AI bookings"

            } today`,

      icon: <CalendarDays size={23} />,

    },

    {

      label: "AVG. DURATION",

      value:

        metrics.avgDurationSeconds == null

          ? "—"

          : formatDuration(metrics.avgDurationSeconds),

      helper:

        metrics.avgDurationSeconds == null

          ? "No call data yet"

          : "Average call duration today",

      icon: <Clock3 size={23} />,

    },

  ];



  return (

    <motion.section

      initial={{ opacity: 0, y: 6 }}

      animate={{ opacity: 1, y: 0 }}

      className="mb-4 grid gap-3 md:grid-cols-3"

    >

      {cards.map((card) => (

        <div

          key={card.label}

          className="flex min-w-0 items-center gap-3 rounded-xl border border-[#DCE9DF] bg-[#FFFDF8] px-4 py-3 shadow-[0_3px_10px_rgba(16,44,45,0.025)]"

        >

          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#E8F4EF] text-[#087D82]">

            {card.icon}

          </div>



          <div className="min-w-0">

            <p className="text-[10px] font-semibold tracking-[0.13em] text-[#82939D]">

              {card.label}

            </p>



            <p className="mt-0.5 text-[23px] font-semibold leading-tight tracking-tight text-[#102C2D]">

              {card.value}

            </p>



            <p className="mt-0.5 text-[11px] leading-4 text-[#82939D]">

              {card.helper}

            </p>

          </div>

        </div>

      ))}

    </motion.section>

  );

}





function ActiveReceptionist({ config, metrics }) {

  const navigate = useNavigate();

  return (

    <motion.div

      initial={{ opacity: 0 }}

      animate={{ opacity: 1 }}

      className="mb-6"

    >

      <div className="mb-5 grid gap-4 md:grid-cols-3">

        <MetricCard

          icon={<Phone size={18} />}

          label="CALLS TODAY"

          value={metrics.callsToday}

          helper={

            metrics.callsToday === 0

              ? "No calls yet"

              : `${metrics.callsToday} ${

                  metrics.callsToday === 1 ? "call" : "calls"

                } handled today`

          }

        />



        <MetricCard

          icon={<CalendarDays size={18} />}

          label="APPOINTMENTS"

          value={metrics.aiAppointmentsToday}

          helper={

            metrics.aiAppointmentsToday === 0

              ? "No AI bookings yet"

              : `${metrics.aiAppointmentsToday} ${

                  metrics.aiAppointmentsToday === 1

                    ? "AI booking"

                    : "AI bookings"

                } today`

          }

        />



        <MetricCard

          icon={<Clock3 size={18} />}

          label="AVG. DURATION"

          value={

            metrics.avgDurationSeconds == null

              ? "—"

              : formatDuration(metrics.avgDurationSeconds)

          }

          helper={

            metrics.avgDurationSeconds == null

              ? "No call data"

              : "Average call duration today"

          }

        />

      </div>



      <div className="rounded-3xl border border-[#d9e6e7] bg-white p-6 shadow-[0_8px_25px_rgba(15,70,75,0.05)]">

        <div className="flex flex-col justify-between gap-5 md:flex-row md:items-center">

          <div className="flex items-center gap-4">

            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#e7f4f3]">

              <Bot size={22} className="text-[#0d7377]" />

            </div>



            <div>

              <div className="flex items-center gap-2">

                <h2 className="font-semibold text-[#17272d]">

                  {config?.receptionistName || "AI Receptionist"}

                </h2>



                <span className="flex items-center gap-1 rounded-full border border-[#bce5d7] bg-[#effaf6] px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#17856f]">

                  <span className="h-1.5 w-1.5 rounded-full bg-[#21a47e]" />

                  Configured

                </span>

              </div>



              <p className="mt-1 text-sm text-[#788b92]">

                Your receptionist configuration is ready.

              </p>

            </div>

          </div>



          <button

            type="button"

            onClick={() => navigate("/receptionist/setup")}

            className="inline-flex items-center justify-center gap-2 rounded-full border border-[#d8e4e5] px-4 py-2.5 text-sm font-medium text-[#38535b] transition hover:bg-[#f5f9f9]"

          >

            <Settings2 size={16} />

            Configure

          </button>

        </div>

      </div>

    </motion.div>

  );

}



/* -------------------------------------------------------

   SMALL COMPONENTS

\------------------------------------------------------- */



function StatusBadge({ active, label }) {

  return (

    <span

      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.14em] ${

        active

          ? "border-[#bce5d7] bg-[#effaf6] text-[#17856f]"

          : "border-[#eadfbe] bg-[#fff9e8] text-[#9b7725]"

      }`}

    >

      <span

        className={`h-1.5 w-1.5 rounded-full ${

          active ? "bg-[#20a17d]" : "bg-[#d4a93c]"

        }`}

      />

      {label}

    </span>

  );

}



function SectionHeading({ eyebrow, title }) {

  return (

    <div className="mb-4">

      <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#789099]">

        {eyebrow}

      </p>

      <h2 className="mt-1 text-[17px] font-semibold text-[#18292f]">

        {title}

      </h2>

    </div>

  );

}



function StepCard({ number, icon, title, description, muted }) {

  return (

    <div

      className={`rounded-2xl border bg-white p-5 shadow-[0_6px_20px_rgba(15,70,75,0.04)] ${

        muted ? "border-dashed border-[#d8e2e4]" : "border-[#dce7e8]"

      }`}

    >

      <div className="mb-5 flex items-center justify-between">

        <span className="text-[11px] font-semibold tracking-[0.18em] text-[#a0b0b5]">

          {number}

        </span>



        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#eef6f5] text-[#0d7377]">

          {icon}

        </div>

      </div>



      <h3 className="text-sm font-semibold text-[#1a2b31]">{title}</h3>



      <p className="mt-2 text-xs leading-5 text-[#7b8e94]">{description}</p>

    </div>

  );

}



function CapabilityCard({ icon, title, text }) {

  return (

    <div className="rounded-2xl border border-[#dce7e8] bg-white p-5 shadow-[0_6px_20px_rgba(15,70,75,0.04)]">

      <div className="mb-4 flex h-9 w-9 items-center justify-center rounded-xl bg-[#eef6f5] text-[#0d7377]">

        {icon}

      </div>



      <h3 className="text-sm font-semibold text-[#1a2b31]">{title}</h3>



      <p className="mt-1.5 text-xs leading-5 text-[#7b8e94]">{text}</p>

    </div>

  );

}



function StatusCard({ icon, title, value, state }) {

  const stateClasses = {

    success: "bg-[#effaf6] text-[#16846d]",

    pending: "bg-[#fff9e8] text-[#9b7725]",

    neutral: "bg-[#f3f6f7] text-[#809197]",

  };



  return (

    <div className="flex items-center gap-4 rounded-2xl border border-[#dce7e8] bg-white p-5 shadow-[0_6px_20px_rgba(15,70,75,0.04)]">

      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#eef6f5] text-[#0d7377]">

        {icon}

      </div>



      <div className="min-w-0">

        <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#8a9ba0]">

          {title}

        </p>



        <span

          className={`mt-1 inline-flex rounded-full px-2 py-1 text-xs font-medium ${stateClasses[state]}`}

        >

          {value}

        </span>

      </div>

    </div>

  );

}



function MetricCard({ icon, label, value, helper }) {

  return (

    <div className="rounded-2xl border border-[#dce7e8] bg-white p-5 shadow-[0_6px_20px_rgba(15,70,75,0.04)]">

      <div className="flex items-center justify-between">

        <span className="text-[10px] font-semibold tracking-[0.16em] text-[#82959b]">

          {label}

        </span>



        <div className="text-[#0d7377]">{icon}</div>

      </div>



      <div className="mt-3 text-2xl font-semibold tracking-tight text-[#18292f]">

        {value}

      </div>



      <p className="mt-1 text-xs text-[#84969c]">{helper}</p>

    </div>

  );

}



function MiniCapability({ icon, title }) {

  return (

    <div className="flex items-center gap-3 rounded-xl border border-[#e2ebeb] bg-white px-3.5 py-3">

      <div className="text-[#0d7377]">{icon}</div>

      <span className="text-xs font-medium text-[#536970]">{title}</span>

      <CheckCircle2

        size={14}

        className="ml-auto text-[#28a47f]"

      />

    </div>

  );

}



function BuildingIcon() {

  return (

    <svg

      width="19"

      height="19"

      viewBox="0 0 24 24"

      fill="none"

      stroke="currentColor"

      strokeWidth="1.8"

      strokeLinecap="round"

      strokeLinejoin="round"

    >

      <path d="M3 21h18" />

      <path d="M6 21V5l6-2 6 2v16" />

      <path d="M9 9h1" />

      <path d="M14 9h1" />

      <path d="M9 13h1" />

      <path d="M14 13h1" />

      <path d="M10 21v-4h4v4" />

    </svg>

  );

}